import React from 'react';
import './PC.css';
import Beaugeard from '../../img/pc/Beaugeard.png'
import Bura from '../../img/pc/Bura.png'
import Cuesta from '../../img/pc/Cuesta.png'
import Deloitte from '../../img/pc/Deloitte.png'
import DoiTInternational from '../../img/pc/DoiTInternational.png'
import EPAMSystems from '../../img/pc/EPAMSystems.png'
import Khononov from '../../img/pc/Khononov.png'
import Quiroga from '../../img/pc/Quiroga.png'
import Santana from '../../img/pc/Santana.png'
import TribeTech from '../../img/pc/TribeTech.png'
import zupsoujava from '../../img/pc/zupsoujava.png'
import Matłoka from '../../img/pc/Matłoka.png'
import SoftwareMill from '../../img/pc/SoftwareMill.png'
import Kamaruzzaman from '../../img/pc/Kamaruzzaman.png'
import Loza from '../../img/pc/Loza.png'
import Mojix from '../../img/pc/Mojix.png'
import Ritchson from '../../img/pc/Ritchson.png'
import NASA from '../../img/pc/NASA.png'
import Bloch from '../../img/pc/Bloch.png'
import GroupeKEYCONSULTING from '../../img/pc/GroupeKEYCONSULTING.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Santana,
          name: 'Otavio Santana',
          position: 'Software Engineer & Architect',
          ln: 'https://www.linkedin.com/in/otaviojava/',
          tw: 'https://twitter.com/otaviojava',
          github: 'https://github.com/otaviojava',
          logo: zupsoujava,
        },
        {
          photo: Cuesta,
          name: 'Jesus Cuesta',
          position: 'Senior Specialist Lead',
          ln: 'https://www.linkedin.com/in/jesuscuesta/',
          logo: Deloitte,
        },
        {
          photo: Ritchson,
          name: 'Michael Ritchson',
          position: 'Chief Engineer',
          ln: 'https://www.linkedin.com/in/michael-ritchson/',
          logo: NASA,
        },
        {
          photo: Quiroga,
          name: 'Carlos Arturo Quiroga',
          position: 'Digital Architecture Corporate Leader @Pichincha Corp',
          ln: 'https://www.linkedin.com/in/carlosarturoq/',
        },
        {
          photo: Beaugeard,
          name: 'Nick Beaugeard',
          position: `Chief Software Architect`,
          ln: 'https://linkedin.com/in/nickbeaugeard',
          logo: TribeTech,
        },
        {
          photo: Bura,
          name: 'Juriy Bura',
          position: 'Head of Solution Architecture, EPAM Switzerland',
          github: 'https://github.com/Juriy',
          logo: EPAMSystems,
        },
        {
          photo: Khononov,
          name: 'Vlad Khononov',
          position: 'Sr. Cloud Architect',
          ln: 'https://www.linkedin.com/in/vladikk/',
          tw: 'https://twitter.com/vladikk?lang=en',
          github: 'https://github.com/vladikk',
          logo: DoiTInternational,
        },
        {
          photo: Matłoka,
          name: 'Michał Matłoka',
          position: 'Architect',
          ln: 'https://www.linkedin.com/in/mmatloka/',
          tw: 'https://twitter.com/mmatloka',
          logo: SoftwareMill,
        },
        {
          photo: Kamaruzzaman,
          name: 'Md Kamaruzzaman',
          position: 'Enterprise Architect',
          ln: 'https://www.linkedin.com/in/md-kamaruzzaman-54280b10/',
          tw: 'https://twitter.com/KamaruzzMd',
        },
        {
          photo: Loza,
          name: 'Jorge Hugo Loza',
          position: 'Director of Engineering & Principal Architect',
          ln: 'http://www.linkedin.com/in/hugoloza',
          logo: Mojix,
        },
        {
          photo: Bloch,
          name: 'Gaëtan Bloch',
          position: 'Software Architect',
          ln: 'http://www.linkedin.com/in/gaetanbloch',
          tw: 'https://twitter.com/bloch_gaetan',
          github: 'https://github.com/gaetanBloch',
          logo: GroupeKEYCONSULTING,
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pcc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program committee</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}